import { render } from "./Register.vue?vue&type=template&id=df9817ea"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
script.render = render

export default script